import { IFinancing } from "api/interfaces/static-pages/financing.type";
import OldFinancingContainer from "container/financing/OldFinancingContainer";
import Index from "container/financing/financing.container";
import { RootState } from "interfaces/generics.type";
import { useSelector } from "react-redux";
import isFeatureEnabled from "util/helper/isFeatureEnabled";

export default function Financing(props: IFinancing) {
  const auth = useSelector((state: RootState) => state.authenticationState);
  const { expConfigurations } = auth;
  const isAffirmEnabled = isFeatureEnabled(expConfigurations, "affirm");

  if (!isAffirmEnabled) {
    return (<OldFinancingContainer {...props} />);
  }

  return <Index {...props} />;
}
